import { createSelector } from '@ngrx/store';
import { PageContentState } from '../models/assessment-models';

export const selectPageContent = (state: any): PageContentState => state.pageContent;

export const selectNextPageState = createSelector(selectPageContent, (state) => state?.pageContent);

export const selectActionButtons = createSelector(selectNextPageState, ({ data }) => ({
  nextButton: data?.nextButton || false,
  repeatButton: data?.repeatButton || false,
  startTestButton: data?.startTestButton || false,
}));

export const selectDisplayActionButtons = createSelector(
  selectActionButtons,
  ({ nextButton, repeatButton, startTestButton }) => nextButton || repeatButton || startTestButton || false,
);
